// @flow
import { buildOptions, makeRequest } from './ServiceHelpers';
import type { FulfillerModel } from '../models/fulfillerModel';

const endpointUrl = process.env.REACT_APP_IDENTITY_URL;

export const fetchAllFulfillers = (): Promise<Array<FulfillerModel>> => {
  const options = buildOptions();

  return makeRequest(endpointUrl, '/v1/fulfillers?showArchived=false', options, 'getting fulfillers list')
    .then(response => {
      return response.fulfillers.map(fulfiller => ({
        id: fulfiller.fulfillerId,
        name: fulfiller.fulfillerName,
        accountId: fulfiller.accountId
      }));
    })
    .catch(err => {
      if (err.statusCode === 403) {
        return [];
      } else {
        throw err;
      }
    });
};

export const fetchAccountIdForTheGivenFulfiller = (fulfillerId): Promise<Array<FulfillerModel>> => {
  const options = buildOptions();

  return makeRequest(endpointUrl, '/v1/fulfillers?showArchived=false', options, 'getting fulfillers list')
    .then(response => {
      const fulfillers = response.fulfillers.filter(each => each.fulfillerId === fulfillerId);
      if (fulfillers && fulfillers.length > 0) return fulfillers[0].accountId;
      else return null;
    })
    .catch(err => {
      if (err.statusCode === 403) {
        return [];
      } else {
        throw err;
      }
    });
};
